// What counts as "this client has a payment method" on the enrolment screen.
//
// It decides two things that were both stuck for affiliate-billed clients: whether the LSA can be
// previewed and signed, and whether "Send email" sends the agreement or the old "add your bank
// account" link. Mendy, 3 Sep 2026: "remove the banking hurdle. Meaning let them send out the LSA
// without banking." That link is what he kept getting instead.
//
// The affiliate method arrives SEPARATELY from the other two, and has to: /bankaccounts queries the
// BankAccount discriminator, so it cannot see an affiliate account at all. Widening that endpoint
// would push a third type into the Billing tab grid and everything else that reads it.

const first = (list) => (Array.isArray(list) && list.length ? list[0] : null)

/**
 * The method the enrolment should work against, in order of specificity: a real bank account, then
 * a card, then the affiliate method. Real banking wins because it is the more specific fact and it
 * is what the agreement should be drawn against.
 *
 * The chosen account's id is what the LSA preview and the signing page are drawn against, and the
 * server checks that account belongs to this client before handing over the document — so naming
 * the affiliate account here is exactly what keeps that check working for these clients, rather
 * than leaving them with no account to name.
 */
export const resolveBillingMethod = ({ bankAccounts, cards, affiliateAccount } = {}) => {
  const paymentMethod = first(bankAccounts) || first(cards) || affiliateAccount || null

  return { hasBilling: !!paymentMethod, paymentMethod }
}
